/* ----------------------------------------
    Node Modules
---------------------------------------- */

import anime from 'animejs';

/* ----------------------------------------
    Animations
---------------------------------------- */

const teamAnimationIn = els => {
    anime({
        targets: els.icon,
        translateY: 0,
        scale: [1.2, 1],
        opacity: 1,
        easing: 'easeOutExpo',
        duration: 800
    });

    anime({
        targets: els.name,
        translateY: [25, 0],
        scale: [1.1, 1],
        opacity: 1,
        easing: 'easeOutExpo',
        duration: 650
    });

    anime({
        targets: els.role,
        translateY: [50, 0],
        opacity: 1,
        delay: 50,
        easing: 'easeOutExpo',
        duration: 550
    });
};

const teamAnimationOut = els => {
    anime({
        targets: [els.icon, els.name, els.role],
        translateY: 0,
        scale: 1,
        opacity: 0,
        duration: 500,
        easing: 'easeOutExpo',
        complete: () => {
            ['icon', 'name', 'role'].forEach(item => {
                els[item].style = '';
            });
        }
    });
};

/** ----------------------------------------
    Overlay
 ---------------------------------------- */

export class Team {

    constructor(parent) {
        this.parent = parent;
        this._init();
    }

    /** ----------------------------------------
         Generate Random Number
     ---------------------------------------- */

    _randomNumber(amount) {
        const array = [];

        while(array.length < amount){
            let random = Math.floor(Math.random() * 10);
            if(array.indexOf(random) === -1) array.push(random);
        }

        return array;
    }

    /** ----------------------------------------
         Generate Grid
     ---------------------------------------- */

    _getAmount() {
        const split = this.parent.classList.contains('team__grid--split');
        return split ? 2 : 4;
    }

    _setGrid() {
        const amount = this._getAmount();
        const random = this._randomNumber(amount);

        const min = Math.min(...random);
        const compensate = random.map(number => number - min);

        const select = index => compensate[index];

        this.members.forEach((member, index) => {
            member.style.transform = `translateY(${ select(index % 4) }rem)`;
        });

        this._setPlaceholder(random);
    }

    _setPlaceholder(offset) {
        const placeholder = document.createElement('div');
        placeholder.style.height = Math.max(...offset) + 'rem';
        this.parent.insertAdjacentHTML('afterend', placeholder.outerHTML);
    }

    /** ----------------------------------------
         Set Current
     ---------------------------------------- */

    _setCurrentMember(el) {
        return {
            card: el,
            icon: el.querySelector('.card-team__linkedin'),
            name: el.querySelector('.card-team__name'),
            role: el.querySelector('.card-team__role'),
        };
    }

    /** ----------------------------------------
         Events
     ---------------------------------------- */

    _events() {
        [...this.members].map(member => {
            member.addEventListener('mouseenter', e => {
                teamAnimationIn(this._setCurrentMember(e.currentTarget));
            }, false);

            member.addEventListener('mouseleave', e => {
                teamAnimationOut(this._setCurrentMember(e.currentTarget));
            }, false);
        });
    }

    /** ----------------------------------------
        Initialize
     ---------------------------------------- */

    _init() {
        const teams = this.parent.querySelectorAll('.card-team');
        if(!teams.length) return;

        this.members = teams;

        this._setGrid();
        this._events();
    }

}